import React, { useEffect, useRef, useState } from "react";
import "./Templates.css";
import Container from "react-bootstrap/Container";
import { Row, Col, Modal, Button, Form } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { AssignReportTemplate, GetReportTemplate } from "../../apis/ReportsAPI";
import "@progress/kendo-theme-default/dist/all.css";
import * as AiIcons from "react-icons/ai";
import * as MdIcons from "react-icons/md";
import * as FiIcons from "react-icons/fi";
import { SearchCustomerNames } from "../../apis/CustomerAPI";
import { Link } from "react-router-dom";
import { PDFExport } from "@progress/kendo-react-pdf";
import InvestigatorReport from "../../qcr-common/InvestigatorReport";
import { useAlert } from "react-alert";

export default function ReportTemplates() {
  const pdfExportComponent = useRef(null);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setTemplateId(0);
    setTemplateName("");
    setCustomerId(0);
    setCustomerName("");
    setReportPrice(0);
    setReportName("");

    setShow(false);
  };
  const handleShow = () => setShow(true);
  const [data, setData] = useState([]);
  const alert = useAlert();

  const [templateId, setTemplateId] = useState(0);
  const [templateName, setTemplateName] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const [customerId, setCustomerId] = useState(0);
  const [customerName, setCustomerName] = useState("");
  const [reportPrice, setReportPrice] = useState(0);
  const [reportName, setReportName] = useState("");
  const [reportShow, setReportShow] = useState(false);
  const handleReportClose = () => setReportShow(false);
  const handleReportShow = () => setReportShow(true);
  const [startDownloading, setStartDownloading] = useState(false);

  const exportPDFWithComponent = (id, name) => {
    setTemplateId(id);
    setReportName(name);
    handleReportShow();
  };

  useEffect(() => {
    console.log("start downloading", startDownloading);
    if (pdfExportComponent.current && startDownloading) {
      pdfExportComponent.current.save();
      setTimeout(() => {
        handleReportClose();
      }, 3000);
    }
  }, [startDownloading]);

  useEffect(() => {
    async function GetReportTemplateData() {
      var result = await GetReportTemplate();
      var tmplt = result.data.filter((x) => x.templateName != "Pdf Reports");
      setData(tmplt);
    }
    GetReportTemplateData();
  }, []);

  function assignReport(id) {
    //console.log(data);
    const template = data.filter((templ) => templ.id === id);
    setTemplateId(id);
    setTemplateName(template[0].templateName);
    setReportPrice(template[0].reportPrice);
    handleShow();
  }

  const getCustomerNames = async (e) => {
    var name = e.target.value;
    var custObj = e.target.props.data;
    const cust = custObj.filter((c) => c.customerName === name);
    if (cust.length > 0) {
      setCustomerId(cust[0].customerId);
    }
    setCustomerName(name);
    if (name.length > 2) {
      var result = await SearchCustomerNames(name);
      setCustomerData(result.data);
    }
  };

  const [errorhandleSubmitLists, sethandleSubmitListError] = useState([]);
  //// Validation Function for Report
  function handleSubmitValidate() {
    let isValid = true;
    var errorhandleSubmitList = [];

    /// validation for reportName
    if (templateName === undefined || templateName === "") {
      isValid = false;
      errorhandleSubmitList.push("templateName");
    }

    if (reportName === undefined || reportName === "") {
      isValid = false;
      errorhandleSubmitList.push("reportName");
    }

    // console.log(reportPrice);
    if (reportPrice === 0 || reportPrice < 0) {
      isValid = false;
      errorhandleSubmitList.push("reportPrice");
    }

    console.log(errorhandleSubmitList);
    sethandleSubmitListError(errorhandleSubmitList);
    return isValid;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (handleSubmitValidate()) {
      var assignBody = {
        id: 0,
        totalRows: 0,
        reportCustomerMappingId: 0,
        reportName: reportName,
        reportDescription: "",
        reportPrice: reportPrice,
        customPrice: 0,
        taxStatus: "",
        reportTemplateId: templateId,
        customerId: customerId,
      };

      var result = await AssignReportTemplate(assignBody);

      if (result.data !== 0) alert.success("Report assigned to customer");
      else alert.success("Unable to assign report");
      handleClose();
    }
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Report Templates</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter"></div>
                  </Col>
                </Row>
                <Row>
                  <Grid style={{ height: "75vh" }} data={data} sortable={true}>
                    <GridColumn field="id" title="Template ID" width="120px" />
                    <GridColumn field="templateName" title="Report Name" />
                    <GridColumn
                      field="id"
                      title="View"
                      width="100px"
                      cell={(props) => (
                        <td className="req">
                          <Link
                            to={"/Report?type=preview&id=" + props.dataItem.id}
                            target="_blank"
                          >
                            <AiIcons.AiOutlineEye />
                          </Link>
                        </td>
                      )}
                    />
                    <GridColumn
                      field="id"
                      title="Assign"
                      width="100px"
                      cell={(props) => (
                        <td className="act">
                          <button
                            type="btn"
                            onClick={() => assignReport(props.dataItem.id)}
                          >
                            <MdIcons.MdOutlineAssignmentTurnedIn />
                          </button>
                        </td>
                      )}
                    />
                    <GridColumn
                      field="UnitPrice"
                      title="Download"
                      width="120px"
                      cell={(props) => (
                        <td className="act">
                          <button
                            type="btn"
                            onClick={() =>
                              exportPDFWithComponent(
                                props.dataItem.id,
                                props.dataItem.templateName
                              )
                            }
                          >
                            <FiIcons.FiDownload />
                          </button>
                        </td>
                      )}
                    />
                  </Grid>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>

      <Modal show={reportShow} onHide={handleReportClose} fullscreen>
        <Modal.Body>
          <PDFExport
            ref={pdfExportComponent}
            paperSize="A4"
            margin={40}
            fileName={`${reportName}`}
          >
            <div className="pdf-modal">
              <InvestigatorReport
                type="preview_download"
                templateid={templateId}
                viewLoaded={(loaded) => {console.log(loaded)}}
                previewLoaded={(previewLoaded) => {
                  setStartDownloading(previewLoaded);
                }}
              />
            </div>
          </PDFExport>
        </Modal.Body>
      </Modal>

      <Modal centered show={show} onHide={handleClose}>
        <Modal.Body className="invest-modal">
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Report Template:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="text"
                    value={templateName}
                    className={
                      errorhandleSubmitLists.includes("templateName")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">Customer:</Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <AutoComplete
                    className="custom-select-form-control"
                    data={customerData}
                    placeholder="Customer Name"
                    textField="customerName"
                    value={customerName}
                    onChange={getCustomerNames}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Report Name:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="text"
                    placeholder="XYZ Corp REP"
                    value={reportName}
                    onChange={(e) => setReportName(e.target.value)}
                    className={
                      errorhandleSubmitLists.includes("reportName")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-5" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Report Price:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="text"
                    placeholder="$264.22"
                    value={reportPrice}
                    onChange={(e) => setReportPrice(e.target.value)}
                    className={
                      errorhandleSubmitLists.includes("reportPrice")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>
            <Row className="ordbtn">
              <Col lg={6} md={12} className="btorng">
                <Button type="submit">Assign</Button>
              </Col>
              <Col lg={6} md={12} className="btgry">
                <Button onClick={handleClose}>Cancel</Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
